import React from "react";
import {
  calculateTotalToday,
  calculateTotalThisMonth,
  overUnderBudget,
  calculatePercentThruBudget,
} from "../utils/budgetUtils";
import { calculatePercentThruMonth } from "../utils/calendarUtils";
import { displayColor } from "../utils/utils";

const BudgetSummary = ({ budget, expensesThisMonth, expensesPaginated }) => {
  return (
    <div className="bg-gray-100 p-4 rounded-b-xl drop-shadow-xl">
      <h2 className="m-2 mx-3 text-2xl font-bold text-gray-800">
        Total Spent Today: ${calculateTotalToday(expensesThisMonth).toFixed(0)}
      </h2>
      <h3 className="m-2 mx-3 text-xl font-bold text-gray-700">
        For{" "}
        {new Date().toLocaleDateString(undefined, {
          month: "long",
          day: "numeric",
        })}
        {", we are "}
        {overUnderBudget(expensesThisMonth, budget)}
      </h3>
      <h4 className="m-2 mx-3 text-l font-bold text-gray-600">
        Spent This Month: $
        {calculateTotalThisMonth(expensesThisMonth).toFixed(0)}
      </h4>
      <h4 className="m-2 mx-3 text-l font-bold text-gray-600">
        Remaining This Month: $
        {budget - calculateTotalThisMonth(expensesThisMonth).toFixed(0)}
      </h4>
      <div className="mx-3">
        <h4 className="text-l font-bold text-gray-600">
        🗓️ {calculatePercentThruMonth().toFixed(0)}% through the month
        </h4>
        <div className="w-full h-4 mb-4 bg-gray-200 rounded-full">
          <div
            className="h-4 bg-gradient-to-r from-blue-400 to-blue-600 rounded-full"
            style={{ width: calculatePercentThruMonth() + "%" }}
          ></div>
        </div>
        <h4 className="text-l font-bold text-gray-600">
        💵 {calculatePercentThruBudget(expensesThisMonth, budget).toFixed(0)}%
          through our budget
        </h4>
        <div className="w-full h-4 mb-4 bg-gray-200 rounded-full">
          <div
            className={
              "h-4 rounded-full " + displayColor(expensesThisMonth, budget)
            }
            style={{
              width:
                calculatePercentThruBudget(expensesThisMonth, budget) + "%",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

const ExpenseSummary = ({ totalsByCategory, expensesPaginated }) => {
  return (
    <div className="container mx-auto px-4 bg-gray-100 p-4 rounded-t-lg shadow-lg">
      <h4 className="font-bold text-gray-800 mb-4">
        Total Spent: ${calculateTotalThisMonth(expensesPaginated).toFixed(2)}
      </h4>
      <div className="totals-by-category">
        <ul className="list-disc list-inside text-gray-700">
          {Object.entries(totalsByCategory).map(([category, total]) => (
            <li key={category} className="mb-2">
              <span className="font-semibold">{category}:</span> $
              {total.toFixed(2)}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export { BudgetSummary, ExpenseSummary };
